import { defineStore } from "pinia";
import api from "../api";

// Публичная конфигурация провайдеров логина/регистрации. Секреты (токен
// бота, SMTP, OAuth client secret) хранятся только на бэкенде - фронтенд
// узнаёт лишь "включено/нет", включение любого способа не требует пересборки.
export const useAuthProvidersStore = defineStore("authProviders", {
    state: () => ({
        loaded: false,
        telegramEnabled: false,
        telegramBotUsername: "" as string,
        telegramOidcEnabled: false,
        emailRegistrationEnabled: false,
        googleEnabled: false,
        whatsappEnabled: false,
    }),
    actions: {
        async fetch() {
            if (this.loaded) return;
            try {
                const res = await api.get("/auth/providers");
                this.telegramEnabled = Boolean(res.data?.telegram?.enabled);
                this.telegramBotUsername = res.data?.telegram?.bot_username || "";
                this.telegramOidcEnabled = Boolean(res.data?.telegram_oidc?.enabled);
                this.emailRegistrationEnabled = Boolean(res.data?.email_registration?.enabled);
                this.googleEnabled = Boolean(res.data?.google?.enabled);
                this.whatsappEnabled = Boolean(res.data?.whatsapp?.enabled);
            } catch {
                this.telegramEnabled = false;
                this.telegramBotUsername = "";
                this.telegramOidcEnabled = false;
                this.emailRegistrationEnabled = false;
                this.googleEnabled = false;
                this.whatsappEnabled = false;
            } finally {
                this.loaded = true;
            }
        },
    },
});
